<template>
  <div class="playlist-container">
    <el-row :gutter="12" class="playlist-row">
      <el-col v-if="dataList.length === 0" :span="24" class="empty-box">
        <el-empty description="还没有播放列表呢~" :image-size="160" />
      </el-col>

      <template v-else>
        <el-col
          v-for="(item, index) in dataList"
          :key="index"
          :xs="12"
          :sm="8"
          :md="6"
          :lg="4"
          class="playlist-col"
        >
          <el-card :body-style="{ padding: '0px' }" class="playlist-card" shadow="hover">
            <router-link :to="`/playlist/${item.albumId}`" target="_blank" class="card-link">
              <div class="image-wrapper">
                <el-image
                  lazy
                  fit="cover"
                  class="playlist-cover"
                  :src="item.coverUrl"
                >
                  <div slot="placeholder" class="image-slot">加载中...</div>
                </el-image>

                <div class="badge-top-right">{{ item.duration }}</div>

                <div class="image-overlay">
                  <div class="overlay-left">
                    <span><i class="el-icon-video-play" /> {{ getVisited(item.view) }}</span>
                    <span><i class="el-icon-chat-dot-round" /> {{ getVisited(item.comment) }}</span>
                  </div>
                  <div class="overlay-right">
                    <i :class="item.horizontal ? 'el-icon-monitor' : 'el-icon-mobile-phone'" />
                  </div>
                </div>
              </div>

              <div class="playlist-info">
                <h4 class="playlist-title">{{ item.albumName }}</h4>
              </div>
            </router-link>
          </el-card>
        </el-col>
      </template>
    </el-row>

    <div class="pagination-footer">
      <el-pagination
        background
        :small="screenWidth <= 768"
        hide-on-single-page
        layout="prev, pager, next"
        :page-size="pageSize"
        :current-page="currentPage"
        :total="totalSize"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { getUserAlbumList } from '@/api/vod'
import { handleVisited } from '@/assets/js/utils'

export default {
  name: 'PostAlbumIndex',
  data() {
    return {
      screenWidth: document.body.clientWidth,
      currentPage: 1,
      pageSize: 12,
      totalSize: 0,
      dataList: []
    }
  },
  created() {
    document.title = '播放列表'
    this.getData()
  },
  mounted() {
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth
    }
  },
  methods: {
    handleCurrentChange(pageNumber) {
      this.currentPage = pageNumber
      this.getData()
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    getData() {
      const queryInfo = {
        postType: 2,
        pn: this.currentPage
      }
      getUserAlbumList(queryInfo).then(resp => {
        if (resp.code === 0) {
          this.dataList = resp.data.list
          this.totalSize = resp.data.totalSize
        } else {
          this.$message.warning(resp.msg)
        }
      })
    },
    getVisited(visited) {
      return handleVisited(visited)
    }
  }
}
</script>

<style scoped>
.playlist-container {
  padding: 15px;
  max-width: 1400px;
  margin: 0 auto;
}

.playlist-row {
  margin: 0 !important; /* 修正 el-row 的负 margin 导致的溢出 */
}

.playlist-col {
  margin-bottom: 20px;
}

/* 卡片整体样式 */
.playlist-card {
  border: none;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.3s cubic-bezier(0.2, 0, 0, 1);
  background: #fff;
}

.playlist-card:hover {
  transform: translateY(-4px);
}

.card-link {
  text-decoration: none;
}

/* 封面容器 */
.image-wrapper {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 10; /* 统一比例，防止高度不一 */
  background: #f0f0f0;
  overflow: hidden;
}

.playlist-cover {
  width: 100%;
  height: 100%;
  display: block;
}

/* 顶部时长徽标 */
.badge-top-right {
  position: absolute;
  top: 6px;
  right: 6px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 11px;
  backdrop-filter: blur(4px);
}

/* 底部数据遮罩 (玻璃拟态) */
.image-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 32px;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  color: #fff;
  font-size: 12px;
}

.overlay-left {
  display: flex;
  gap: 12px;
}

.overlay-left i {
  margin-right: 3px;
}

/* 标题信息 */
.playlist-info {
  padding: 12px 10px;
}

.playlist-title {
  margin: 0;
  font-size: 14px;
  color: #303133;
  line-height: 1.4;
  height: 2.8em; /* 限制为两行高度 */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-weight: 500;
}

.playlist-title:hover {
  color: #409EFF;
}

/* 分页 */
.pagination-footer {
  margin-top: 30px;
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
}

.empty-box {
  padding-top: 100px;
}

/* 移动端适配核心 */
@media screen and (max-width: 768px) {
  .playlist-container {
    padding: 8px;
  }

  .playlist-col {
    padding-left: 6px !important;
    padding-right: 6px !important;
    margin-bottom: 12px;
  }

  .playlist-title {
    font-size: 13px;
    height: 2.6em; /* 手机端略微调小 */
  }

  .image-overlay {
    height: 28px;
    font-size: 10px;
    padding: 0 6px;
  }

  .badge-top-right {
    font-size: 10px;
    padding: 1px 4px;
  }
}
</style>
